import React, { useEffect, useRef, useState } from 'react';
import { Button, Input } from 'antd';

import './index.css';
import DatePicker, { DateObject, getAllDatesInRange } from 'react-multi-date-picker';
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import "react-multi-date-picker/styles/layouts/mobile.css"
import "react-multi-date-picker/styles/colors/green.css"
import { CloseCircleFilled } from '@ant-design/icons';
import { BiDice1 } from 'react-icons/bi';
import moment from 'jalali-moment'
import { persianToLatin } from '../../../utils/persianToLatin ';

const DatePickerInput = (props: any) => {
    const datePickerRef = useRef<any>()
    const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"]
    let { value, one, style } = props;    
    const [dataPickerValue, setDataPickerValue] = useState<any>([])
    const [close, setClose] = useState<any>(false)

    const combinedStyle = {
        width: '100%',
        height: 24,
        ...style
    };

    useEffect(() => {       
        if (typeof value === "string" && value !== "") {
            const gregorianDate = moment.from(persianToLatin(value), 'fa', 'YYYY/MM/DD').locale('en').format('YYYY/MM/DD');
            setDataPickerValue(new DateObject({ date: gregorianDate, format: "YYYY/MM/DD" }));
        }
        else
            if (typeof value === "object" && value.length > 0) {
                const d = value.map((x: any) => {
                    const gregorianDate = moment.from(persianToLatin(x), 'fa', 'YYYY/MM/DD').locale('en').format('YYYY/MM/DD')
                    return new DateObject({ date: gregorianDate, format: "YYYY/MM/DD" })
                })
                setDataPickerValue(d);

            }
            else {
                setDataPickerValue(value);
            }
    }, [value]);
    const onHandleCancleDatePicker = () => {
        setClose(true)
    }

    // useEffect(() => {
    //     if (close) {
    //         datePickerRef.current.closeCalendar()
    //         setClose(false)
    //     }
    // }, [close])
    const onHandleCloseDatePicker2 = () => {
        let dd = dataPickerValue
        if (typeof dataPickerValue === "string") {
            dd = new DateObject({ date: dataPickerValue, format: "YYYY/MM/DD" });
        }

        let d: any = []
        d.push(dd.format("YYYY/MM/DD"))
        one(d)              
    }

    

    const onHandleCloseDatePicker = (v:any) => {       
        //setDataPickerValue(v)
        if(v){
        let dd = v
        if (typeof v === "string") {
            dd = new DateObject({ date: v, format: "YYYY/MM/DD" });
        }

        let d: any = []
        d.push(dd.format("YYYY/MM/DD"))
        one(d)
    }             
    }

    const clearDate = () => {
        setDataPickerValue([]);
        one([])
    };

    return (
        <div className="date-picker-container">
            <DatePicker
                //ref={datePickerRef}
                onOpenPickNewDate={false}
                //onClose={() => close}
                portal
                style={combinedStyle}
                containerStyle={{ width: '100%' }}
                value={dataPickerValue}
                onChange={(v)=>onHandleCloseDatePicker(v)}
                calendar={persian}
                locale={persian_fa}
                calendarPosition="left"
                //className="rmdp-mobile"
                //className="green"
                weekDays={weekDays}
                className="green"
                //range={isRange}
                //dateSeparator=" تا "
                weekStartDayIndex={0}
            >
                {/* <div>
                <Button
                        style={{ marginBottom: 5, marginRight:10 }}                        
                        onClick={onHandleCancleDatePicker}
                    >
                        لغو
                    </Button>

                    <Button
                        style={{ marginBottom: 5 }}
                        type='primary'
                        onClick={onHandleCloseDatePicker}
                    >
                        تائید
                    </Button>                    
                </div> */}
            </DatePicker>
            {value.length > 0 && (
                <CloseCircleFilled
                    className="clear-icon"
                    onClick={clearDate}
                />
            )}
        </div>)
};

export default React.memo(DatePickerInput);